import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_WEEKLY_BLOCK_REQUEST,
  FETCH_WEEKLY_BLOCK_SUCCESS,
  FETCH_WEEKLY_BLOCK_ERROR,
  SAVE_WEEKLY_BLOCK_REQUEST,
  SAVE_WEEKLY_BLOCK_SUCCESS,
  SAVE_WEEKLY_BLOCK_ERROR,
} from 'actionTypes'

/*
 * REQUEST WEEKLY BLOCK
 */
export const fetchWeeklyBlock = (auth, query) => (dispatch) => {
  dispatch(fetchWeeklyBlockRequest())

  return new Api(auth.user.dsToken, dispatch)
    .get(API_URL.WEEKLY_BLOCK_FIND, query)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(fetchWeeklyBlockSuccess(response.data))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchWeeklyBlockError(error))
      dispatch(hideSpinner())
    })
}

export const fetchWeeklyBlockRequest = () => ({
  type: FETCH_WEEKLY_BLOCK_REQUEST,
})

export const fetchWeeklyBlockSuccess = (data) => ({
  type: FETCH_WEEKLY_BLOCK_SUCCESS,
  payload: data,
})

export const fetchWeeklyBlockError = (error) => ({
  type: FETCH_WEEKLY_BLOCK_ERROR,
  payload: error.dsMessage,
})

/*
 * SAVE WEEKLY BLOCK
 */
export const updateWeeklyBlock = (auth, block, callback) => (dispatch) => {
  dispatch(updateWeeklyBlockRequest())

  return new Api(auth.user.dsToken, dispatch)
    .post(API_URL.WEEKLY_BLOCK_SAVE, block)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(updateWeeklyBlockSuccess(response.data))
      dispatch(hideSpinner())
      callback && callback()
    })
    .catch((error) => {
      dispatch(updateWeeklyBlockError(error))
      dispatch(hideSpinner())
    })
}

export const updateWeeklyBlockRequest = () => ({
  type: SAVE_WEEKLY_BLOCK_REQUEST,
})

export const updateWeeklyBlockSuccess = (data) => ({
  type: SAVE_WEEKLY_BLOCK_SUCCESS,
  payload: data,
})

export const updateWeeklyBlockError = (error) => ({
  type: SAVE_WEEKLY_BLOCK_ERROR,
  payload: { error },
})
